export default {
  getCustomerLocation: (state) => state.customerLocation,
};
